import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { EventHistoryItem } from '@fc-core/notifications/models/event-history-item';
import { BackendResponse } from '@fc-core/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private http = inject(HttpClient);

  getEventsHistory(
    next: string | null,
    selectedTab: string,
  ): Promise<{ events: EventHistoryItem[]; next: string | null }> {
    // A DRF `next` URL already carries page, page_size and type — appending
    // params again duplicates them and breaks pagination on filtered tabs.
    let url = environment.apiUrl + 'api/notifications/';
    let params = new HttpParams();
    if (next) {
      url = next;
    } else {
      params = params.set('page_size', '20');
      if (selectedTab !== 'all') {
        params = params.set('type', selectedTab);
      }
    }
    return lastValueFrom(
      this.http.get<BackendResponse<EventHistoryItem[]>>(url, { params }).pipe(
        map((response) => {
          return { events: response.results, next: response.next ?? null };
        }),
      ),
    );
  }

  markAsRead(eventId: string): Promise<EventHistoryItem> {
    return lastValueFrom(
      this.http.post<EventHistoryItem>(
        environment.apiUrl + 'api/notifications/' + eventId + '/read/',
        {},
      ),
    );
  }

  markAllAsRead(ids: string[]): Promise<string[]> {
    return lastValueFrom(
      this.http
        .post<{ ids: string[] }>(
          environment.apiUrl + 'api/notifications/bulk_read/',
          {
            ids,
          },
        )
        .pipe(
          map((response: { ids: string[] }) => {
            return response.ids;
          }),
        ),
    );
  }
}
